// extracted by mini-css-extract-plugin
export default {"buttonDiv":"News_buttonDiv__D0BJG","selectStoreRoleDiv":"News_selectStoreRoleDiv__wGYok","title":"News_title__b9Byj"};